import type { MailContentProps, MailMetadata } from "../../lib/types";
import { calculateDateWithDateRelative } from "../../lib/utils";
import { MailSignature } from "../mail/mail-signature";

function DemandeConges({ variablesData }: MailContentProps) {
  return (
    <div className="space-y-2">
      <p className="pb-4">Bonjour,</p>
      <p>
        Je souhaite vous informer de ma demande de congés du{" "}
        {calculateDateWithDateRelative(
          Number(variablesData.secretaire_date_debut_conges) || 0,
        )}{" "}
        au{" "}
        {calculateDateWithDateRelative(
          Number(variablesData.secretaire_date_fin_conges) || 0,
        )}
        , qui avait été préalablement approuvée par{" "}
        {variablesData.genre_masc_abrege}{" "}
        {variablesData.responsable_grand_est_precedent_nom} avant son départ.
        Malgré l'inconfort de vous adresser cette requête sans avoir eu
        l'opportunité de bien nous connaître, la situation requiert que je m'en
        tienne aux plans établis, d'autant plus que j'ai déjà engagé des frais
        non remboursables pour ce voyage à Cuba avec mes amis.
      </p>
      <p>
        Le contexte récent a été marqué par une intensification de ma charge de
        travail suite au départ de {variablesData.genre_masc_abrege}{" "}
        {variablesData.responsable_grand_est_precedent_nom}, ce qui m'a
        considérablement éprouvé. Cette pause est pour moi essentielle ; elle
        représente une opportunité de me ressourcer. Je me suis longuement
        préparée à ces vacances et je suis convaincue que le repos et le
        changement d'environnement me permettront de revenir avec un nouvel élan
        pour assumer mes responsabilités avec vigueur et détermination.
      </p>
      <p>
        En prévision de votre arrivée et afin de garantir une transition en
        douceur,
        <span>
          {" "}
          j'ai d'ores et déjà pris les devants en vous envoyant les dossiers en
          attente laissés par {variablesData.genre_masc_abrege}{" "}
          {variablesData.responsable_grand_est_precedent_nom} sur votre boite
          mail
        </span>
        .
      </p>
      <p>Sincères salutations,</p>
      <MailSignature
        emetteurLogo={DemandeConges.metadata.emetteurLogo}
        emetteur={DemandeConges.metadata.emetteur}
        emetteurPoste={DemandeConges.metadata.emetteurPoste}
        emetteurEntreprise={DemandeConges.metadata.emetteurEntreprise}
      />
    </div>
  );
}

DemandeConges.metadata = {
  titre: "Demande de congés",
  cleMail: "demande_conges",
  messageTransfert: false,
  emetteur: "Nicole SON",
  emetteurPoste: "Assistante de Direction",
  emetteurEntreprise: "SYTEL Grand Est",
  emetteurLogo: "/logos/sytel_grand_est.png",
  dateRelative: 0,
  piecesJointes: [],
} as MailMetadata;

export default DemandeConges;
